export default __webpack_public_path__ + "static/media/ksivalue_cube@2x.6491b8e8.jpg";